import { render, staticRenderFns } from "./PublicTenderModal.vue?vue&type=template&id=6d58419c&scoped=true&"
import script from "./PublicTenderModal.vue?vue&type=script&lang=js&"
export * from "./PublicTenderModal.vue?vue&type=script&lang=js&"
import style0 from "./PublicTenderModal.vue?vue&type=style&index=0&id=6d58419c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d58419c",
  null
  
)

export default component.exports